import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {devConfig} from "../../../config/config"; // Importing development configuration

/**
 * MarketingVsRegistrosView class extends JetView to create a specific view for marketing vs registrations.
 */
export default class MarketingVsRegistrosView extends JetView {
	/**
	 * Configures the layout of the view.
	 * @returns {Object} The configuration object for the view.
	 */
	config(){
		const _ = this.app.getService("locale")._; // Localization service for text translation
		return {
			type:"clean", // Clean layout type
			rows:[
				{ template:_("Marketing Vs Registros"), type:"header", css:"webix_header chart_header" }, // Header template
				{
					view:"chart", type:"scatter", // Scatter chart configuration
					localId:"chart2", // Local ID for referencing the chart
					xValue: "#register#", // X-axis value mapping
					value:"#value#", // Y-axis value mapping
					item:{
						borderColor:"#fff", // Item border color
						color:"#8664C6", // Item fill color
						shadow:false, // Disable shadow
						radius:7, // Item radius
						type:"d" // Item type
					},
					xAxis:{
						start:0, // X-axis start value
						lines:false, color:"#EDEFF0", // X-axis line visibility and color
						title:"Registros" // X-axis title
					},
					yAxis:{
						start:0, // Y-axis start value
						step:200, // Y-axis step value
						color:"#fff", lineColor:"#EDEFF0", // Y-axis color and line color
						title:"Valor" // Y-axis title
					},
					tooltip:{
						template:"<b>Marketing: #marketing# </b><br> Registros: #register# Clicks: #value# " // Tooltip template for data points
					},
				}
			]
		};
	}

	/**
	 * Initializes the view and sets up event listeners.
	 */
	init() {
		const cur_user = this.getParam("league", true); // Get current user parameter
		var vthis = this; // Preserve context for callback functions

		// Event listener for marketing vs registrations statistics
		this.on(this.app,"statisticsAgent:marketingvsregistros",data => {
			vthis.$$("chart2").clearAll(); // Clear existing chart data
			vthis.$$("chart2").parse(data); // Parse new data into the chart
		});

		// Event listener for date changes
		this.on(this.app,"statisticsAgent:date2",date => {
			var dateRange=date; // Store the date range
			webix.ajax().headers({
				"Content-type": "application/json" // Set content type for AJAX request
			}).post(devConfig.geturlApi() + "Agent/GetMarketingStats", '{ "AgentId":' + cur_user + ', "FromDateLocal":"' + dateRange.FromDateLocal + '", "ToDateLocal":"' + dateRange.ToDateLocal + '"}', {
				error: function (text, data, XmlHttpRequest) {
					webix.message("Error! "); // Display error message on failure
				},
				success: function (text, data, XmlHttpRequest) {
					var data = JSON.parse(text); // Parse the response text to JSON
					vthis.$$("chart").clearAll(); // Clear existing chart data
					vthis.$$("chart").parse(data.result.charts.MediaStat.records); // Parse new data into the chart
				}
			});
		});
	}
}

// FILE DOCUMENTED
